import {

  CORE_LOAD_ALLAMENITY_REQUEST,
  CORE_LOAD_ALLAMENITY_SUCCESS,
  CORE_LOAD_ALLAMENITY_FAILURE,

  CORE_LOAD_AMENITYINFO_REQUEST,
  CORE_LOAD_AMENITYINFO_SUCCESS,

  CORE_SEARCH_AMENITY_REQUEST,
  CORE_SEARCH_AMENITY_SUCCESS,

} from '../../../types'

const initialState = []
export default {
  amenity: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALLAMENITY_REQUEST:
      case CORE_SEARCH_AMENITY_REQUEST:
        return initialState

      case CORE_LOAD_ALLAMENITY_SUCCESS:
      case CORE_SEARCH_AMENITY_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  amenityMaster: (state = "REQUEST", action) => {
    switch (action.type) {
      case CORE_LOAD_ALLAMENITY_REQUEST:
        return "REQUEST"
      case CORE_LOAD_ALLAMENITY_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALLAMENITY_FAILURE:
        return []
      default:
        return state
    }
  },
  amenityInfo: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_AMENITYINFO_REQUEST:
        return initialState

      case CORE_LOAD_AMENITYINFO_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/settings/amenity/reducer.js